<template>
  <div class="sample-section">
    <h1>应用示范</h1>
    <div class="sample_wrapper">
      <a class="sample_item" href="https://www.tiandiweitong.com/Location.html" target="_blank">
        <img src="../../assets/home/6-1.png" alt="tiandiweitong" />
        <p>www.tiandiweitong.com</p>
      </a>
      <a class="sample_item" href="http://www.fanxingiot.cn/" target="_blank">
        <img src="../../assets/home/6-2.png" alt="fanxingiot" />
        <p>www.fanxingiot.com</p>
      </a>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.sample-section {
  margin: 80px 0px;
  h1 {
    margin: 0;
    text-align: center;
    font-size: 28px;
    font-weight: 400;
    color: #0d0e24;
  }
  .sample_wrapper {
    width: 1200px;
    margin: 0 auto;
    margin-top: 70px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .sample_item {
      text-decoration: none;
      p {
        text-align: center;
      }
    }
  }
}
</style>